import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client'

interface Phone {
  number: string | null
}

interface Consent {
  id: string
  type: string
  hasGivenConsent: boolean
}

interface FacebookAccount {
  friendsCount: number
}

interface TwitterAccount {
  id: string
}

interface Cart {
  id: string
}

interface UserDevice {
  name: string | null
}

interface NotificationInboxMessages {
  unreadMessageCount: number
}

export interface LoggedInUser {
  id: string
  intercomVerificationId: string
  city: string | null
  phone: Phone
  locationCountryCode: string
  avatar: string | null
  firstname: string | null
  lastname: string | null
  successfullySoldCount: number
  isEmployee: boolean | null
  hasAgreedToLatestTermsAndPrivacyPolicy: boolean | null
  createdAt: string
  email: string | null
  isPhoneVerified: boolean
  isEmailVerified: boolean
  isPartner: boolean | null
  isTicketProvider: boolean | null
  consent: Consent[] | null
  facebookAccount: FacebookAccount | null
  twitterAccount: TwitterAccount | null
  cart: Cart | null
  locale: string
  userDevices: UserDevice[] | null
  notificationInboxMessages: NotificationInboxMessages | null
}

export const GET_LOGGED_IN_USER = gql`
  query getLoggedInUserInfo {
    loggedInUser {
      id
      intercomVerificationId
      city
      phone {
        number
      }
      locationCountryCode
      avatar
      firstname
      lastname
      successfullySoldCount
      isEmployee
      hasAgreedToLatestTermsAndPrivacyPolicy
      selectedPayoutMethod {
        name
        fields {
          name
          value
        }
      }
      createdAt
      email
      isPhoneVerified
      isEmailVerified
      isPartner
      isTicketProvider
      consent {
        id
        type
        hasGivenConsent
      }
      facebookAccount {
        friendsCount
      }
      twitterAccount {
        id
      }
      cart {
        id
      }
      locale
      userDevices {
        name
      }
      notificationInboxMessages {
        unreadMessageCount
      }
    }
  }
`

const getLoggedInUser = async (apolloClient: ApolloClient<NormalizedCacheObject>) => {
  try {
    const { data } = await apolloClient.query({
      query: GET_LOGGED_IN_USER,
    })

    if (data.loggedInUser !== null) {
      return data.loggedInUser
    }
  } catch {}

  return null
}

export default getLoggedInUser
